import ApiService from "service/Api";

const LogActivityService = {
  getLogActivities: async (
    page: number,
    search: string,
    limit: number,
    filterGroupActivity: string,
    filterPortal: string
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_group_activity: filterGroupActivity,
        filter_portal: filterPortal,
      },
      url: "admin/log-activities",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getAllGroupActivies: async () => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/log-activities/group-activities",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default LogActivityService;
